import './HeaderHamburgerButton.scss';

export type HeaderHamburgerButtonProps = {
	isOpened: boolean;
	isUserTypeVisible: boolean;
	onClick: () => void;
};

const HeaderHamburgerButton: React.FC<HeaderHamburgerButtonProps> = ({
	isOpened,
	onClick,
	isUserTypeVisible,
}) => {
	const isOpenedClass = isOpened ? 'is-opened' : '';

	return (
		<div
			className={['blk-ac-header-hamburger-button', isOpenedClass].join(' ')}
			aria-expanded={isOpened}
			onClick={onClick}
		>
			<button type="button" className="front-of-bg">
				{/* 
				Class value (hamburger-box) is mandatory.
				We must keep it because of masthead.js code.
				It will look after this element by class name and it can cause positioning issue,
				if it is missing.
				*/}
				<span aria-hidden="true" className="hamburger-box"></span>
			</button>
			{isUserTypeVisible && <i className="icon-bell fa fa-bell front-of-bg" />}
		</div>
	);
};

export default HeaderHamburgerButton;
